var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"breadcrumb has-arrow-separator",attrs:{"aria-label":"breadcrumbs"}},[_c('ul',_vm._l((_vm.items),function(item,index){return _c('li',{key:'bc-'+index,class:{ 'is-active': item.active }},[_c('router-link',{attrs:{"to":item.to}},[_vm._v(_vm._s(item.title))])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }